var exports = {
  "R3": "TimestampRenderer.module__tooltipContainer___Sy0zRm",
  "Mp": "TimestampRenderer.module__tooltipFullDateTime___Sy0zRm",
  "fv": "TimestampRenderer.module__tooltipRelativeTime___Sy0zRm",
};

module.exports = exports;
